import { useEffect } from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { ProfileContent } from "../../components/ProfileContent";
import { MEMBER_MENU } from "../../lib/menus";

export default function MemberProfile() {
  useEffect(() => { document.title = "Profil - DS KODE"; }, []);
  return (
    <DashboardLayout title="Profil" menu={MEMBER_MENU} testid="member-profile">
      <ProfileContent />
    </DashboardLayout>
  );
}
